import BaseDashboardLayout from '../BaseDashboardLayout/BaseDashboardLayout'
import NavigatorMenu from '../NavigatorMenu/NavigatorMenu'
import { resolveProductCategoryByPath } from '@/router/pageConst'
import { useLocation } from 'react-router-dom'

function PersistentDashboardLayout() {
  const { pathname } = useLocation()
  const productType = resolveProductCategoryByPath(pathname)

  return <BaseDashboardLayout sidebar={<NavigatorMenu productType={productType} />} />
}

export default PersistentDashboardLayout
